/**
 * @fileoverview Define local-calendar and numeric form boundaries shared by `AppDateInput.js` and `AppNumberInput.js`. Empty numeric input remains null rather than becoming zero; calendar dates remain local dates rather than UTC timestamps. Domain validation, units, and persistence remain with the consuming form.
 */



export function formatDateForInput(value) {
    if (!value) return ''
    const dateObj = new Date(value)
    if (Number.isNaN(dateObj.getTime())) return ''
    const year = dateObj.getFullYear()
    const month = String(dateObj.getMonth() + 1).padStart(2, '0')
    const day = String(dateObj.getDate()).padStart(2, '0')
    return `${year}-${month}-${day}`
}



export function parseDateInput(value) {
    if (!value) return null
    const [year, month, day] = value.split('-').map(Number)
    return new Date(year, month - 1, day)
}



export function parseNumberInput(value) {
    if (value === '') return null
    const parsed = Number(value)
    return Number.isNaN(parsed) ? null : parsed
}
